var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowcircleup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 2.66668C8.63616 2.66668 2.66683 8.63601 2.66683 16C2.66683 23.364 8.63616 29.3333 16.0002 29.3333C23.3642 29.3333 29.3335 23.364 29.3335 16C29.3335 8.63601 23.3642 2.66668 16.0002 2.66668Z",
    fill: "white",
    stroke: "#3b82f6",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7065 14.32L15.9999 19.0133L11.2932 14.32",
    stroke: "#3b82f6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowcircleup);
export default __webpack_public_path__ + "static/media/arrowcircleup.423c8224d6f54e54bc1306b6a1d7345f.svg";
export { ForwardRef as ReactComponent };